export default __webpack_public_path__ + "static/Azulberry-a0010be3d0511c4f806e735f04a0274b.png";